import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { ButtonGroupFlexBox } from "@/components/Layout/ButtonGroupFlexBox/ButtonGroupFlexBox";

type Props = {
  onConfirm: () => void | Promise<void>;
  isConfirming?: boolean;
};

export const InvalidBasketStatusModal: FC<Props> = ({
  onConfirm,
  isConfirming = false,
}) => {
  const { t } = useTranslation("portal", { keyPrefix: "add-device" });

  return (
    <Modal
      title={t("invalidBasket.title")}
      onClose={() => {
        if (!isConfirming) {
          void onConfirm();
        }
      }}
      hasScroll={false}
      variant="dark"
    >
      <div className="flex flex-col gap-6">
        <p className="text-body-base text-foreground-primary-inverse">
          {t("invalidBasket.description")}
        </p>

        <ButtonGroupFlexBox
          className="!mt-0"
          rightAligned
          forceButtonWidth
          primaryButton={
            <Button
              dataTestid="invalid-basket-restart"
              variant="primary"
              inverted
              loading={isConfirming}
              onClick={() => void onConfirm()}
            >
              {t("invalidBasket.confirm")}
            </Button>
          }
        />
      </div>
    </Modal>
  );
};
